module.exports = __webpack_public_path__ + "static/media/Annual_Oration.3047ef2f.md";